import React, { useState } from 'react';
import './Header.css';
import { StaticQuery, graphql } from 'gatsby';
import Sidebar from '../Sidebar/Sidebar';
import logoSvg from '../../images/logo.svg';
import burgerSvg from '../../images/Burger.svg';

const Header = () => {
  const [expanded, setExpanded] = useState(false);
  const onClickHamburguer = () => {
    setExpanded(!expanded);
  };

  return (
    <StaticQuery
      query={graphql`
        query HeadingQuery {
          headerItems: allContentfulHeaderItem(sort: { order: ASC }) {
            nodes {
              id
              category
              items {
                id
                url
                text
              }
            }
          }
        }
      `}
      render={(data) => (
        <div className="header__container">
          <Sidebar isExpanded={expanded} sidebarData={data.headerItems.nodes[1]} />
          <div className="navbar">
            {data.headerItems.nodes.map(({ id, category, items }) => {
              switch (category) {
                case 'Start':
                  return (
                    <div id="nav__logo" key={id}>
                      <button
                        type="button"
                        className="sidebar__burger icon__button"
                        onClick={() => onClickHamburguer()}
                      >
                        <img src={burgerSvg} alt="burger" />
                      </button>
                      {items.map((item) => {
                        return (
                          <a href={item.url} key={item.id} target="_blank" rel="noreferrer">
                            <img src={logoSvg} className="logo" alt="logo" />
                          </a>
                        );
                      })}
                    </div>
                  );
                case 'Middle':
                  return (
                    <div id="nav__middle" key={id}>
                      {items.map((item) => {
                        return (
                          <a href={item.url} key={item.id} target="_blank" rel="noreferrer">
                            {item.text}
                          </a>
                        );
                      })}
                    </div>
                  );
                default:
                  return (
                    <div id="nav__end" key={id}>
                      {items.map((item) => {
                        return (
                          <a
                            href={item.url}
                            key={item.id}
                            target="_blank"
                            rel="noreferrer"
                            aria-label={item.text}
                            className={`header__anchor__${item.text.toLowerCase()}`}
                          >
                            {item.text === 'Login' ? <p id="login__text">{item.text}</p> : null}
                            <i
                              className={`header__icon ${item.text.toLowerCase()}`}
                              alt={item.text}
                            />
                          </a>
                        );
                      })}
                    </div>
                  );
              }
            })}
          </div>
        </div>
      )}
    />
  );
};

export default Header;
